import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CreateItemApiModel } from '@app/api/api-models/CreateItemApiModel';
import { MoveApiModel } from '@app/api/api-models/MoveApiModel';
import { PeFormListApiModel, PpFormApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PpFormsService {
  public apiUrl = 'pp-forms';

  constructor(private readonly http: HttpClientService) {}

  public getList(): Observable<Array<PeFormListApiModel>> {
    return this.http.get<Array<PeFormListApiModel>>(`${this.apiUrl}/get-list`);
  }

  public getById(id: number): Observable<PpFormApiModel> {
    return this.http
      .get<PpFormApiModel>(`${this.apiUrl}/get/${id}`)
      .pipe(map((data) => new PpFormApiModel().deserialize(data)));
  }

  public move(model: MoveApiModel<number>): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/move`, model);
  }

  public add(model: CreateItemApiModel): Observable<PpFormApiModel> {
    return this.http.post<PpFormApiModel>(`${this.apiUrl}/create`, model);
  }

  public delete(id: number): Observable<Object> {
    return this.http.delete(`${this.apiUrl}/delete/${id}`);
  }

  public update(model: PpFormApiModel): Observable<PpFormApiModel> {
    return this.http
      .put<PpFormApiModel>(`${this.apiUrl}/update`, model)
      .pipe(map((data) => new PpFormApiModel().deserialize(data)));
  }
}
